import { Pipe, PipeTransform } from "@angular/core";
import { environment } from "src/environments/environment";
// import { environment } from '../../environments/environment';

@Pipe({
  name: "image",
  standalone: true,
  pure: false
})
export class ImagePipe implements PipeTransform {
  transform(value: string, arg1: any) {
    if (value && value.includes("http")) {
      return value;
    } else if (value && value != "null") {
      if (arg1 != "evento") {
        return environment.DOWNLOAD_URL + "/" + value;
      } else {
        return environment.BACKEND_IMG_URL + "/" + value;
      }
    } else {
      /** quando sem foto no contribua adiciona imagem padrão */
      if (arg1 == "contribua") {
        return environment.IMG_URL + "/placeholder-contribua.png";
      }

      if (arg1 == "evento") {
        return environment.IMG_URL + "/not_found.png";
      }

      if (arg1 == "culto") {
        return "https://sis.sistemaprover.com.br/public/img/icones-app/cloud.jpg";
      }

      if (arg1 == "enquete") {
        return "assets/imgs/enquete_placeholder.png";
      }

      return "assets/imgs/placeholder.jpg";
    }
  }
}
